import script from "./CategoriesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&setup=true&lang=js"

export default script